var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"section-title-edit",on:{"click":function($event){return _vm.$emit('input', !_vm.value)}}},[(_vm.value)?_c('i',{staticClass:"fas fa-times"}):_c('i',{staticClass:"fas fa-edit"}),_vm._v(" "+_vm._s(_vm.value ? "Cancel Editing" : "Edit Information")+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }